
// import {fire, fireAuth} from '@/firebase/config'
import { useStore } from "vuex";
import { onMounted, ref, provide } from "vue";
import { a, n } from "@/composables/types";
import useCss from "@/composables/useCss";
// import { useRouter, useRoute } from "vue-router";

export default {
  // components: [],
  setup() {
    const ss = useStore().state;
    // const sg = useStore().getters;
    ///////////////////////

    ///////////css////////////
    const { slide, cqueA, cLenEqual } = useCss();
    //......................................
    // const slide = x => {};
    //
    // let cards = ref();
    onMounted(() => {
      const slider = document.querySelector<HTMLElement>('.artc-slider')
      const allitems = document.querySelectorAll<HTMLElement>('.artc-item-outside')

      if(slider && allitems){
        slider.style.transform = `translateX(30px)`;
        slider.style.width = 
          `calc(   (100% - (30px * 2)) * ${ss.articles.length/3}  )`
        allitems.forEach((item)=>{
          item.style.width = `${100 / (ss.articles.length)}%` //100 / 10 10%
        })
      }


      // cards = ref(cqueA(".artc-item-outside"));
      // console.log(cards.value.length);
      // return { cards };
    });
    ////////////////////////
    return {
      ss,
      slide
    };
  }
};
